import { useRouter } from "next/router";
import ErrorPage from "next/error";
import { ReactElement, useEffect } from "react";
import { PageSeo } from "src/components/SEO";
import PostHeader from "src/components/molecules/PostHeader";
import RichContent from "src/components/organisms/RichContent";
import TwoStackColumn from "src/components/organisms/TwoStackColumn";
import Faq from "src/components/organisms/Faq";
import siteMetadata from "src/data/siteMetadata";
import {
  PostParsed,
  PostContentElement,
} from "src/services/contentful/post/postParser";
import LeadFormSection from "src/components/forms/LeadForm";
import { BlockRenderer } from "src/components/molecules/BlockRenderer";
import {
  IPage,
  IPageFields,
  IPageGenericPage,
  IPageGenericPageFields,
} from "src/types/generated/contentful";
import ErrorBoundary from "src/components/ErrorBoundary";
import Head from "next/head";
import ArticleSchema from "@src/components/schemas/ArticleSchema";

declare global {
  interface Window {
    dataLayer: any[] | undefined;
    blueshift: any;
  }
}

const ContentTypeToComponentMap = {
  richContent: RichContent,
  twoStackColumn: TwoStackColumn,
  faq: Faq,
};

export type GenericPagePageProps = {
  page: IPageGenericPageFields;
};

// TODO: add back the generic page props remove any
export default function GenericPage(data: any): ReactElement {
  const { teamMember } = data;
  const router = useRouter();

  const slug = teamMember?.fields?.slug;
  if (!slug) {
    console.error("ERROR: no slug found", JSON.stringify(teamMember));
  }
  const seoTitle = teamMember?.fields?.name
    ? teamMember?.fields?.name
    : teamMember?.fields?.seo?.fields?.title;
  const seoDescription = teamMember?.fields?.jobTitle
    ? `${teamMember?.fields?.name} : ${teamMember?.fields?.jobTitle}`
    : teamMember?.fields?.seo?.fields?.description;
  const seoImages = teamMember?.fields?.profileImage
    ? [teamMember?.fields?.profileImage]
    : teamMember?.fields?.seo?.fields?.images;
  const noIndex = teamMember?.fields?.seo?.fields?.no_index
    ? teamMember?.fields?.seo?.fields?.no_index
    : false;
  const noFollow = teamMember?.fields?.seo?.fields?.no_follow
    ? teamMember?.fields?.seo?.fields?.no_follow
    : false;

  // TODO: adding blueshift tracking
  //const blueshiftProductId: string = page?.blueshiftProductId;

  // useEffect(() => {
  //   if (typeof blueshiftProductId !== "undefined") {
  //     window.dataLayer = window.dataLayer || [];
  //     if (window.blueshift) {
  //       window.dataLayer.push({
  //         event: "blogArticleView",
  //         blueshiftProductId,
  //       });
  //     } else {
  //       window.dataLayer.push({
  //         blueshiftProductId,
  //       });
  //     }
  //   }
  // }, [blueshiftProductId]);

  if (!router.isFallback && !teamMember) {
    return <ErrorPage statusCode={404} />;
  }

  if (router.isFallback) {
    return <div>Loading…</div>;
  }

  return (
    <>
      <Head>
        <title>{seoTitle}</title>
      </Head>
      <PageSeo
        url={`${siteMetadata.mainSiteUrl}/team-member/${slug}`}
        title={seoTitle}
        description={seoDescription}
        images={seoImages}
        nofollow={noFollow}
        noindex={noIndex}
        datePublished={new Date(teamMember?.sys?.createdAt).toISOString()}
        dateModified={new Date(teamMember?.sys?.updatedAt).toISOString()}
        authorName={teamMember?.fields?.seo?.fields?.author?.name}
        authorPicture={teamMember?.fields?.seo?.fields?.authorPicture}
      />

      <article>
        {/*<PostHeader post={page} />*/}
        <div>
          <BlockRenderer
            block={teamMember}
            layoutId={teamMember["data-layoutid"]}
          />
        </div>
        {/*<LeadFormSection
          formVerticalAlignment={"Top"}
          formHorizontalAlignment={"Left"}
  />*/}
  
      </article>
    </>
  );
}
